const curDate = new Date();

/**
 * State for getAppointment module
 */
export const state = {
  /**
   * Increment when an appointment is loading and decrease it when loading is complete.
   * Display spinner when greater than 0
   */
  loadingGetAppointment: 0,

  // These are used for showing the appointments
  /**
   * Selected day of month.
   */
  selectedDayOfMonth: curDate.getDate(),
  /**
   * Selected month
   */
  selectedMonth: curDate.getMonth(),
  /**
   * Selected year
   */
  selectedYear: curDate.getFullYear(),

  // These are used for the weekly swiper and monthly swiper
  /**
   * Selected day of the month
   */
  selectedWeek: curDate.getDate(),
  /**
   * Selected month
   */
  selectedWeekMonth: curDate.getMonth(),
  /**
   * Selected year
   */
  selectedWeekYear: curDate.getFullYear(),

  /**
   * All the distinct dates which have appointments.
   *
   * Format
   * {
   *    [provider_id]: string[] // Eg: [ "2020-02-03", "2020-02-04" ]
   * }
   */
  appointmentDates: {},

  /**
   *  All years which have already been queried from
   *  Thses are years for which disctinct appointment dates have been fetched
   *  Used for proper caching
   *
   *  Format
   * {
   *    [provider_id]: int[] // Eg [2020, 2021]
   * }
   */
  yearsAlreadyQueried: {},

  /**
   * All the appointments which were fetched
   *
   * Format
   * {
   *    [date ("2020-02-03")] : {
   *      id:388224 // The appointment id
   *      app_date:"2020-08-23" // The date of the appointment
   *      app_end_hh:3 // End time hour
   *      app_end_mm:31 // End time minute
   *      app_end_tt:0 // End time AM(0) or PM(1)
   *      app_oth_event:"" The other event name if the "event_appointment" is saved as "only this"
   *      app_start_hh:2 // Start time hour
   *      app_start_mm:46 // Start time minute
   *      app_start_tt:0 // Start time AM(0) or PM(1)
   *      app_type:0 // Appointment type Client(0), Other(1)
   *      appointment_repeat_id: 388224 // If appointment type is repeat, this is the repeat appointment id
   *      appointmentrepeat_id: 0
   *      client_id:3507 // Client id if it is a client appointment
   *      client_type:0 // Client type
   *      starts_from:"2020-08-18" // If repeat appointment, this is the start repeat date
   *      end_on:"2020-09-18" // If repeat appointment, this is the end repeat date
   *      id_note:null // Note id if there is any
   *      is_all_day:0 // If appointment is a repeat appointment. No(0), Yes(1)
   *      is_brokenrepeated:0 // If the appointment is a broken repeat. No(0), Yes(1)
   *      is_cancelled:0 // If the appointment is cancelled. No(0), Yes(1)
   *      is_deleted:0 // If the appointment is deleted. No(0), Yes(1)
   *      is_video:0 // If the appointment is video. No(0), Yes(1)
   *      firstName:"Hello" // The first name if any
   *      lastName:"World" // The last name if any
   *      middleName:"" // The middle name if any
   *      namePrefix:"" // Name prefix if any
   *      nameSuffix:"" // Name suffix if any
   *      notes:null // Notes if any present, or null
   *      open_note_id:null // The open note id
   *      otherevent_id:0 // The other event id, if this is an other event
   *      otherevent_name:null // The other event name like group name, person name or event_appointment name
   *      otherevent_type:0 // The other event type if the type is other event
   *      own_notes:null // The own notes if any
   *      provider_id:2213 // The provider id or doctor id
   *      reminder_set_status:0 // If there is any reminder status
   *      repeat:4 // The repeat type
   *      repeat_by:0 // The repeat by
   *      repeat_freq:1 // The repeat frequency
   *      repeat_on:"0,1" // Week doys on which repeat
   *      repeats:1 // If it is a repeat appointment
   *      secure_video_session_id:null // The secure video id if any
   *      type:1 // Appointment type. Office(0), Video(2), Phone(3)
   *      video_appointment_id:null // Video appointment id if any
   *    }[]
   * }
   */
  appointments: {},

  /**
   * All the dates for which appointment details were already fetched
   *
   * Format
   * {
   *    [provider_id 2213]: ["2020-08-30", "2020-08-31", "2020-09-13", "2020-09-14"]
   * }
   */
  appointmentDatesAlreadyQueried: {},

  /**
   * Stores the coordinates where each month in monthly view is for proper scroll behaviour
   *
   * Format
   * {
   *    [month number (0 indexed) 0-11]: {
   *      x:0, // X postion of the corordinate
   *      y:758 // Y position of the coordinate
   *    }
   * }
   */
  monthCoordinates: {},

  /**
   * For animating week swipe
   */
  showWeeks: true,

  /**
   * For formatting the client name as per calendar settings
   */
  clientNameFormat: 1,

  /**
   * For ordering the client name as per calendat settings
   */
  clientNameOrder: 1,

  /**
   * Weather to show montly calendar or split view
   */
  showSplitScreenMonthly: false
};
